import api from "./api";

export const remitoTemplatesService = {
  async getDatosEmpresa(idEmpresa) {
    const response = await api.get(`/remito-templates/empresa/${idEmpresa}/datos`);
    return response.data;
  },
  async getTemplateActivo(idEmpresa) {
    const response = await api.get(`/remito-templates/empresa/${idEmpresa}/active`);
    return response.data;
  },
  async getTemplateById(id) {
    const response = await api.get(`/remito-templates/${id}`);
    return response.data;
  },
  async listarTemplates(idEmpresa) {
    const response = await api.get(`/remito-templates/empresa/${idEmpresa}`);
    return response.data;
  },
  async crearTemplate(payload) {
    const response = await api.post(`/remito-templates`, payload);
    return response.data;
  },
  async actualizarTemplate(id, payload) {
    const response = await api.put(`/remito-templates/${id}`, payload);
    return response.data;
  },
  async eliminarTemplate(id) {
    const response = await api.delete(`/remito-templates/${id}`);
    return response.data;
  },
  async duplicarTemplate(id, nuevoNombre) {
    const response = await api.post(`/remito-templates/${id}/duplicate`, { nuevoNombre });
    return response.data;
  },
  async getConfigDefault() {
    const response = await api.get(`/remito-templates/config-default`);
    return response.data;
  },
  async uploadLogo(idEmpresa, file) {
    const formData = new FormData();
    formData.append("logo", file);
    const response = await api.post(`/remito-templates/upload-logo/${idEmpresa}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  }
};
export default remitoTemplatesService;
